import $ from 'jquery'

$('.js-path-select').on('change', event => {
  const $target = $(event.currentTarget).val()
  if ($target != '') {
    window.location.href = $target
  }
})
